import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import { getLanguageCookie } from "./LanguageFunctions";
import { getCachedTranslation, setCachedTranslation } from "./TranslationCache";

// Custom backend that checks cache first for en-US translations
class CachedHttpBackend extends HttpApi {
  constructor(services, backendOptions = {}, i18nextOptions = {}) {
    super(services, backendOptions, i18nextOptions);
  }

  read(language, namespace, callback) {
    // Handle both en-US and en with the same cached English translation
    if (
      (language === "en-US" || language === "en") &&
      namespace === "translation"
    ) {
      const cachedTranslation = getCachedTranslation();
      if (cachedTranslation) {
        return callback(null, cachedTranslation);
      }
    }

    super.read(language, namespace, (error, data) => {
      if (!error) {
        if (language === "en-US" && namespace === "translation" && data) {
          setCachedTranslation(data);
        }
      } else {
        if (language === "en" && namespace === "translation") {
          const cachedTranslation = getCachedTranslation();
          if (cachedTranslation) {
            return callback(null, cachedTranslation);
          }
        }
      }
      callback(error, data);
    });
  }
}

// Initialize i18next with cached HTTP backend
i18n
  .use(CachedHttpBackend)
  .use(initReactI18next)
  .init({
    lng: getLanguageCookie() || "en-US", // use saved language preference
    fallbackLng: "en-US", // fallback language

    backend: {
      loadPath: "/locales/{{lng}}/translation.json", // path to translation files
      addPath: "/locales/{{lng}}/translation.json",
      allowMultiLoading: false,
      crossDomain: false,
      withCredentials: false,
      requestOptions: {
        mode: "cors",
        credentials: "same-origin",
        cache: "default"
      }
    },

    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
